var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpTools",style:(_vm.isIphone?'':'bottom:48px')},[_c('div',{staticClass:"container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"container-item",on:{"click":function($event){return item.click()}}},[_c('div',[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }